import * as Yup from 'yup'

const blastWhatsappSchema = Yup.object().shape({
  id: Yup.number()
    .required('Required'),
  receiver: Yup.string()
    .required('Required'),
  template_name: Yup.string()
    .required('Required'),
  is_test    : Yup.bool(),
  // test_number : Yup.string().when('is_test', {
  //   is   : (value) => value === true,
  //   then : Yup.string().when('channel',{
  //     is   : (value) => value === 'whatsapp',
  //     then : Yup.string()
  //       .min(10, 'At least 10 digits')
  //       .max(13, 'Maximal 13 digits') // since using 62 in backend validation
  //       .matches(/^(^628)(\d{8,13})$/, 'Please input valid numbers, e.g: 6281234567890')
  //       .required('Required')
  //   })
  // }),
  test_email : Yup.string().when('is_test', {
    is   : (value) => value === true,
    then : Yup.string().when('channel', {
      is   : (value) => value === 'push_notification',
      then : Yup.string()
        .email('Test email must be a valid email')
        .required('Required')
    })
  }),
  csv: Yup.mixed()
    .required('A CSV file is required')
    .test('fileType', 'Only CSV files are allowed', (value) => value && [ 'text/csv', 'application/vnd.ms-excel' ].includes(value.type)
    ),
  tinkerlust_dynamic_contents: Yup.object().shape({
    title: Yup.array().of(
      Yup.object().shape({
        resource: Yup.string()
          .required('Required'),
        content_number: Yup.number()
          .required('Required'),
        attribute: Yup.string()
          .required('Required'),
        value: Yup.string()
          .required('Required'),
        formatting: Yup.string()
          .required('Required')
      })
    ),
    body: Yup.array().of(
      Yup.object().shape({
        resource: Yup.string()
          .required('Required'),
        content_number: Yup.number()
          .required('Required'),
        attribute: Yup.string()
          .required('Required'),
        value: Yup.string()
          .required('Required'),
        formatting: Yup.string()
          .required('Required')
      })
    )
  }),
  whatsapp_dynamic_contents: Yup.object().shape({
    body: Yup.array().of(
      Yup.object().shape({
        resource: Yup.string()
          .required('Required'),
        content_number: Yup.number()
          .required('Required'),
        attribute: Yup.string()
          .required('Required'),
        value: Yup.string()
          .required('Required'),
        formatting: Yup.string()
          .required('Required')
      })
    )
  })
})

export default blastWhatsappSchema
